import { toJS } from 'mobx';
import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { commonApi } from 'src/services';

import { CodeGroupModel, ICodeGroupModel } from '../../models';

/**
 * # CommonCdStore
 *
 * CommonCdStore을 설명하세요.
 */
export const CommonCdStore = types
  .model('CommonCdStore')
  // --------------------------------------------------------------------------
  .props({
    commonCds: types.optional(types.array(CodeGroupModel), []),
  })
  // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((self) => ({
    getCommonCdByName(name: string) {
      return toJS(self.commonCds.find((item) => item.name === name)?.list || []);
    },
  }))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    /**
     * commonCds을 교체
     *
     * @param `commonCds` 새로운 모델의 배열
     */
    setCommonCds: (commonCds: ICodeGroupModel[]) => {
      self.commonCds.replace(commonCds);
    },
  }))
  .actions((self) => ({
    getCommonCds: async () => {
      const result = await commonApi.getCommonCds();
      if (result) {
        self.setCommonCds(result);
      }
    },
  }))
  .actions((self) => ({
    // 모델 생성 시 공통코드 조회
    afterCreate() {
      self.getCommonCds();
    },
  }));

// --------------------------------------------------------------------------
type TCommonCdStore = Instance<typeof CommonCdStore>;
type TCommonCdStoreSnapshot = SnapshotOut<typeof CommonCdStore>;

export interface ICommonCdStore extends TCommonCdStore {}
export type TCommonCdStoreKeys = keyof TCommonCdStoreSnapshot & string;
export interface ICommonCdStoreSnapshot extends TCommonCdStoreSnapshot {}
export const createCommonCdStore = () => types.optional(CommonCdStore, {} as TCommonCdStore);
